
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Innovacrystaonrentinmumbai() {



    const cardData =
    {
        keyword: ' Innova Crysta on Rent in Mumbai ',
        heading: 'Deva Cabs: Innova Crysta on Rent in Mumbai ',
        headingDescription: 'Deva Cabs offers premium, comfortable, and hassle-free Innova Crysta rentals in Mumbai, ideal for family trips, corporate travel, and airport transfers. Whether you are planning a long-distance outstation journey, a local sightseeing tour, or a business trip, our Innova Crysta ensures a smooth and luxurious ride. With spacious interiors, ample luggage space, and reclining captain seats, your travel experience is elevated in every way. Enjoy the comfort of dual AC, top-notch maintenance, and professional chauffeurs with every ride from Deva Cabs.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

   "topPlaces": [
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive is a 3.6-kilometer-long arc-shaped boulevard that stretches from Nariman Point to Girgaon Chowpatty. Also known as the 'Queen’s Necklace' for its glowing curve of street lights at night, it is a beloved seaside promenade for evening walks, breezy bike rides, and romantic sunsets. The backdrop of art deco buildings and the peaceful sound of waves create a rare urban serenity, making Marine Drive a timeless retreat in the heart of Mumbai."
  },
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "Located at the waterfront in Colaba, the Gateway of India is Mumbai’s most iconic monument. Built in 1924 to honor the visit of King George V and Queen Mary, this massive basalt arch combines Indo-Saracenic architecture with colonial flair. Overlooking the Arabian Sea and facing the Taj Mahal Palace Hotel, it serves as a central tourist hub, with ferry rides to Elephanta Caves and local photographers capturing the city’s vibrant pulse. The Gateway is not just a historic landmark—it’s a symbol of Mumbai’s pride and resilience."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are a complex of ancient Hindu and Buddhist rock-cut temples located on Elephanta Island, about 11 km from Mumbai. These 5th–8th century caves are renowned for their incredible sculptures of Lord Shiva, particularly the 20-foot-high Trimurti—the three-faced form of Shiva representing creation, preservation, and destruction. The island is accessible by ferry from the Gateway of India and offers a tranquil and culturally enriching day trip."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "The Shree Siddhivinayak Ganapati Mandir is one of Mumbai’s most spiritually significant landmarks, drawing millions of devotees each year. Dedicated to Lord Ganesha, the temple is famous for its beautiful black stone idol with a curved trunk and diamond-studded forehead. Rich in faith, energy, and devotion, the temple also showcases architectural beauty with its carved wooden doors and gold-plated sanctum. Tuesday is considered especially auspicious for darshan, attracting celebrities and commoners alike."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "location": "Mumbai, Maharashtra",
    "description": "A majestic example of Indo-Gothic architecture, Chhatrapati Shivaji Maharaj Terminus is both a UNESCO World Heritage Site and one of India’s busiest railway stations. Designed by British architect F.W. Stevens in 1887, it features elaborate stone carvings, pointed arches, domes, and turrets. The station is a vital part of Mumbai’s daily life while also standing as a living monument to the city’s colonial legacy and artistic grandeur."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is a bustling stretch of sandy coastline in suburban Mumbai, popular for sunsets, local street food, and Bollywood vibes. From joggers and kite-flyers to food stalls selling vada pav, bhel puri, and kulfi, the beach offers a true slice of Mumbai life. Celebrities often frequent nearby luxury homes, and the beach hosts cultural performances and film shoots throughout the year. It's the perfect blend of leisure and local flavor."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Built in the 15th century, the Haji Ali Dargah is a white-domed Indo-Islamic shrine located on an islet off the coast of Worli. The dargah houses the tomb of Sufi saint Haji Ali Shah Bukhari and is accessible via a narrow causeway during low tide. The spiritual calm, rhythmic sea waves, and panoramic sea views create a unique experience for visitors of all faiths. It is one of the most peaceful and scenic religious sites in Mumbai."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Spread across 104 square kilometers, Sanjay Gandhi National Park is Mumbai’s green oasis and a rare natural reserve within a bustling metropolis. The park is home to leopards, deer, monkeys, and countless bird species. A major highlight is the Kanheri Caves—ancient Buddhist cave carvings over 2,000 years old. With toy train rides, cycling trails, nature walks, and boating, the park is a perfect weekend escape for families, nature lovers, and adventure seekers."
  },
  {
    "title": "Chor Bazaar",
    "location": "Bhendi Bazaar, South Mumbai, Maharashtra",
    "description": "One of the oldest and most legendary flea markets in India, Chor Bazaar is a chaotic maze of shops offering antiques, Bollywood posters, vintage cameras, old clocks, and second-hand furniture. Despite the name (meaning 'Thieves Market'), it's a legal and vibrant place known for unexpected treasures and bargaining fun. Whether you're a collector or a curious explorer, this market is a true reflection of Mumbai’s vibrant street economy and layered history."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, Mumbai, Maharashtra",
    "description": "Girgaon Chowpatty is a central beach located at the northern end of Marine Drive. Known for its lively ambiance, it becomes a focal point during Ganesh Chaturthi for idol immersions. Food stalls offer classic Mumbai street snacks like pani puri, pav bhaji, and kulfi. Families, couples, and students often gather here to watch the sunset, fly kites, or simply relax by the sea. The beach offers both spiritual and recreational charm right in the heart of the city."
  }
],



    "services": [
  {
    "name": "Innova Crysta on Rent in Mumbai",
    "description": "Deva Cabs offers premium Innova Crysta on rent in Mumbai, perfect for comfortable city travel, outstation trips, or special occasions. Our Crystas are spacious, fully air-conditioned, and driven by courteous chauffeurs. Enjoy plush interiors, ample luggage space, and a smooth ride every time. Book with flexible rental options and transparent pricing."
  },
  {
    "name": "Book Innova Crysta Mumbai",
    "description": "Booking an Innova Crysta in Mumbai is easy with Deva Cabs. Whether it’s a family outing, business trip, or airport transfer, our Innova Crystas offer unmatched comfort and reliability. Choose your preferred timing and get instant confirmation with our simple online booking system."
  },
  {
    "name": "Luxury Innova Crysta hire Mumbai",
    "description": "Travel in style with Deva Cabs’ luxury Innova Crysta hire service in Mumbai. Perfect for executive travel, VIP movements, and weddings. Our fleet includes top-condition Crystas featuring leather seats, climate control, and extra legroom. Enjoy a luxurious and relaxing experience at affordable rates."
  },
  {
    "name": "AC Innova Crysta rental Mumbai",
    "description": "Beat the Mumbai heat with our AC Innova Crysta rentals. Deva Cabs offers fully air-conditioned Innova Crystas with powerful cooling, reclining seats, and smooth suspension. Great for both local and long-distance journeys with maximum comfort."
  },
  {
    "name": "Innova Crysta for outstation Mumbai",
    "description": "Planning a trip outside Mumbai? Rent an Innova Crysta with Deva Cabs for a safe and enjoyable outstation journey. Our vehicles are ideal for long drives, with excellent mileage, roomy interiors, and experienced drivers who know all key routes and destinations."
  },
  {
    "name": "Mumbai to Pune Innova Crysta cab",
    "description": "Travel from Mumbai to Pune in comfort with our Innova Crysta cab services. Ideal for business meetings, family travel, or solo rides — our cabs come with experienced chauffeurs, on-time pickups, and competitive rates. One-way or round trip options available."
  },
  {
    "name": "Wedding Innova Crysta hire Mumbai",
    "description": "Deva Cabs provides Innova Crystas for wedding events in Mumbai. Perfect for guest transport, bride/groom entry, or VIP movement, our wedding rentals offer clean vehicles, courteous drivers, and a hassle-free experience. Make your special day more elegant and comfortable."
  },
  {
    "name": "Mumbai airport Innova Crysta taxi",
    "description": "Book a chauffeur-driven Innova Crysta for airport pickup or drop in Mumbai. Our professional drivers ensure timely arrival, and our spacious Crystas provide room for all your luggage. 24/7 availability and fixed pricing make airport travel convenient and stress-free."
  },
  {
    "name": "Innova Crysta for family trips Mumbai",
    "description": "Planning a family outing? Hire an Innova Crysta in Mumbai with Deva Cabs for safe, spacious, and comfortable travel. With ample room, AC, and entertainment options, our vehicles make family trips enjoyable from start to finish."
  },
  {
    "name": "Innova Crysta for sightseeing Mumbai",
    "description": "Explore Mumbai’s famous spots in style with our sightseeing Innova Crysta rentals. Deva Cabs offers customized packages for local tours including popular attractions. Travel with an experienced driver, in comfort, and at your own pace."
  },
  {
    "name": "Corporate Innova Crysta hire Mumbai",
    "description": "For executive-level comfort and punctuality, hire a corporate Innova Crysta in Mumbai with Deva Cabs. Ideal for business meetings, client pickups, and company travel. Clean, quiet, and well-maintained vehicles driven by trained professionals."
  },
  {
    "name": "Chauffeur-driven Innova Crysta Mumbai",
    "description": "All Deva Cabs’ Innova Crystas are chauffeur-driven, ensuring a relaxed ride across Mumbai or beyond. Our drivers are experienced, background-verified, and well-versed with city routes. Perfect for those who value comfort, safety, and professionalism."
  },
  {
    "name": "Long trip Innova Crysta rental Mumbai",
    "description": "Going on a long journey from Mumbai? Rent a reliable and comfortable Innova Crysta with Deva Cabs. Our vehicles are serviced regularly and offer ample space, AC, and smooth driving performance—ideal for intercity or multi-day tours."
  },
  {
    "name": "Book Innova Crysta online Mumbai",
    "description": "Enjoy quick and hassle-free online booking for Innova Crysta in Mumbai with Deva Cabs. Get instant quotes, confirm availability, and choose your vehicle type—all from the comfort of your home. Transparent billing and 24/7 support included."
  },
  {
    "name": "Affordable Innova Crysta rental Mumbai",
    "description": "Looking for a budget-friendly yet premium vehicle? Deva Cabs offers affordable Innova Crysta rental in Mumbai with no compromise on quality. Enjoy low fares, clean interiors, and professional service across all routes and events."
  },
  {
    "name": "Premium Innova Crysta cab Mumbai",
    "description": "Book a premium Innova Crysta cab in Mumbai for your travel needs with Deva Cabs. Whether for business, leisure, or special occasions, our cabs offer elegance, comfort, and a smooth travel experience with courteous drivers."
  }
],
"tableData": [
  ["Innova Crysta on Rent in Mumbai", "-Book Innova Crysta Mumbai"],
  ["Luxury Innova Crysta hire Mumbai", "-AC Innova Crysta rental Mumbai"],
  ["Innova Crysta for outstation Mumbai", "-Mumbai to Pune Innova Crysta cab"],
  ["Wedding Innova Crysta hire Mumbai", "-Mumbai airport Innova Crysta taxi"],
  ["Innova Crysta for family trips Mumbai", "-Innova Crysta for sightseeing Mumbai"],
  ["Corporate Innova Crysta hire Mumbai", "-Chauffeur-driven Innova Crysta Mumbai"],
  ["Long trip Innova Crysta rental Mumbai", "-Book Innova Crysta online Mumbai"],
  ["Affordable Innova Crysta rental Mumbai", "-Premium Innova Crysta cab Mumbai"]
],

whychoose: [
  {
    "WhyChooseheading": "Spacious and Luxurious Comfort for Group Travel",
    "WhyChoosedescription": "Our Innova Crysta rentals offer ample space and premium comfort, making them perfect for family outings, corporate trips, or small group tours in and around Mumbai. Enjoy plush seating and a smooth ride that keeps every passenger relaxed."
  },
  {
    "WhyChooseheading": "Perfect for Long-Distance and Outstation Journeys",
    "WhyChoosedescription": "The Innova Crysta is designed for long drives with powerful performance and superior ride quality. Whether you’re heading for a weekend getaway or an intercity trip, our vehicles ensure a reliable and comfortable journey without any hassles."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers know Mumbai’s roads and highways well. They prioritize your safety, punctuality, and comfort, ensuring a stress-free travel experience throughout your rental period."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans to Fit Your Schedule",
    "WhyChoosedescription": "We provide hourly, daily, and custom rental packages to suit your travel needs. Whether you need the Innova Crysta for city travel or multi-day trips, we offer options that are convenient and budget-friendly."
  },
  {
    "WhyChooseheading": "Modern Features for a Comfortable Ride",
    "WhyChoosedescription": "Each Innova Crysta comes equipped with air conditioning, spacious interiors, ample luggage space, and advanced safety features, delivering a pleasant and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Costs",
    "WhyChoosedescription": "Deva Cabs offers competitive and transparent pricing for Innova Crysta rentals, allowing you to plan your trip with confidence and no surprise charges."
  },
  {
    "WhyChooseheading": "24/7 Vehicle Availability and Easy Booking",
    "WhyChoosedescription": "Book your Innova Crysta anytime through our website or customer support. Whether it’s a last-minute trip or a planned journey, we ensure hassle-free and round-the-clock service."
  },
  {
    "WhyChooseheading": "Well-Maintained and Safe Vehicles",
    "WhyChoosedescription": "Safety is our top priority. Our Innova Crysta vehicles undergo regular maintenance and safety inspections, featuring seat belts, GPS tracking, and clean interiors for your peace of mind."
  }
]





















    }










const faqData = [
  {
    question: "Can I rent an Innova Crysta in Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers Innova Crysta rentals in Mumbai for local travel, airport transfers, outstation trips, and more."
  },
  {
    question: "What is the seating capacity of the Innova Crysta?",
    answer: "The Innova Crysta can comfortably seat 6 to 7 passengers, making it ideal for small families or business travel."
  },
  {
    question: "Is the Innova Crysta suitable for long-distance travel?",
    answer: "Absolutely. The Innova Crysta is known for its spacious interiors, smooth ride quality, and powerful performance—perfect for long journeys."
  },
  {
    question: "Can I hire an Innova Crysta for outstation trips from Mumbai?",
    answer: "Yes, you can book an Innova Crysta for outstation trips to destinations like Pune, Lonavala, Mahabaleshwar, and more."
  },
  {
    question: "Is a driver included with the Innova Crysta rental?",
    answer: "Yes, all Innova Crysta bookings include a professional driver to ensure safe and hassle-free travel."
  },
  {
    question: "How do I book an Innova Crysta in Mumbai?",
    answer: "You can book through our website, mobile app, or by calling our customer service team for personalized booking assistance."
  },
  {
    question: "What are the rental charges for an Innova Crysta in Mumbai?",
    answer: "The charges depend on the trip type, distance, and duration. Contact us for a customized quote based on your travel needs."
  },
  {
    question: "Is the Innova Crysta available for airport transfers in Mumbai?",
    answer: "Yes, we provide prompt and comfortable airport transfer services with our Innova Crysta fleet."
  },
  {
    question: "Are there additional charges for tolls, parking, or waiting time?",
    answer: "Any additional charges like tolls, parking, or waiting time will be clearly mentioned during the booking for full transparency."
  },
  {
    question: "Why choose Deva Cabs for Innova Crysta rental in Mumbai?",
    answer: "We offer clean, well-maintained vehicles, courteous drivers, and competitive pricing—making Deva Cabs a preferred choice for Innova Crysta rentals."
  }
];

const testimonialData = [
  {
    id: 3,
    name: 'Mrs. Anita Mehra',
    role: 'Business Traveler',
    review: 'Booked an Innova Crysta with Deva Cabs for a client visit. The car was in top condition and the driver was punctual and professional. Great experience!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 4,
    name: 'Mr. Rajesh Nair',
    role: 'Family Vacationer',
    review: 'Our family trip to Mahabaleshwar was made extra comfortable thanks to the spacious and smooth Innova Crysta from Deva Cabs. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Mumbai",
  "image": "https://devacab.com/assets/images/innova-crysta-on-rent-mumbai.jpg", // Replace with actual image URL
  "description": "Rent luxury Innova Crysta cars in Mumbai with Deva Cabs. Perfect for outstation trips, airport transfers, weddings, family outings, corporate travel, and sightseeing. AC, chauffeur-driven, and affordable options available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/innova-crysta-on-rent-in-mumbai" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Innova Crysta on Rent in Mumbai | Luxury & Chauffeur Driven | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Innova Crysta on rent in Mumbai with Deva Cabs. Luxury AC cars for outstation trips, weddings, airport transfers, family tours, corporate travel, and sightseeing. Affordable chauffeur-driven service." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta on Rent in Mumbai, Book Innova Crysta Mumbai, Luxury Innova Crysta hire Mumbai, AC Innova Crysta rental Mumbai, Innova Crysta for outstation Mumbai, Mumbai to Pune Innova Crysta cab, Wedding Innova Crysta hire Mumbai, Mumbai airport Innova Crysta taxi, Innova Crysta for family trips Mumbai, Innova Crysta for sightseeing Mumbai, Corporate Innova Crysta hire Mumbai, Chauffeur-driven Innova Crysta Mumbai, Long trip Innova Crysta rental Mumbai, Book Innova Crysta online Mumbai, Affordable Innova Crysta rental Mumbai, Premium Innova Crysta cab Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Innovacrystaonrentinmumbai;